<!-- Referral Button -->
@if (canSeeReferralButton) {
  <button
    class="menu-button has-icon"
    mat-menu-item
    (click)="referAFriendClicked()"
  >
    <emperor-icon name="user_share_1"></emperor-icon>
    <span>Refer a friend!</span>
  </button>
}
<!-- Logout Button -->
<button
  class="menu-button has-icon logout-button"
  mat-menu-item
  (click)="logoutClicked()"
>
  <emperor-icon name="logout_2"></emperor-icon>
  <span>Log Out</span>
</button>
